<template lang="html">
    <div class="content">
        <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
                <div class="row g-0 align-self-center align-items-center justify-content-center" id="contactTitle">
                    <div class="cta-3 text-primary">Signalement en cours</div>
                </div>
                <button
                    type="button"
                    :class="{'btn-success': hasSentEmail, 'btn-outline-primary': !hasSentEmail}"
                    class="btn btn-sm btn-icon btn-icon-only ms-1 ms-auto"
                    data-bs-toggle="modal"
                    :data-bs-target="'#note-modal'+content.uid"
                >
                    <i class="bi-app-indicator"></i>
                </button>
                <button type="button"  @click="delete_state()" class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1"><i class="bi-trash"></i></button>
            </div>
            <div class="text-alternate">{{ human_created_on }}</div>

            <textarea style=" resize: both;" class="form-control mt-2" v-model="content.data.text" :ref="'text'" placeholder="Texte du signalement" aria-describedby="button-area" rows="6"></textarea>
            
            <hr/>
                <StateComments :comments="content.data.comments" :active="context.active" @comments:added="update_data" @comments:updated="update_data"></StateComments>
            <hr/>
            <a href="#" class="d-flex align-items-center pt-2" data-bs-toggle="collapse" data-bs-target="#private-note" aria-expanded="true" aria-controls="private-note"><i class="text-primary bi-lock"></i> Note privée ?</a>
            <div class="collapse" id="private-note">
                <form class="row gx-3 gy-2 pt-2 align-items-center collapse d-flex align-items-center">
                    <div class="input-group">
                        <textarea style=" resize: both;" v-model="content.data.mhr_note" :ref="'mhr_note'" class="form-control" placeholder="Votre note privée" aria-describedby="button-area" rows="2"></textarea>
                    </div>

                </form>

            </div>
        </div>
    </div>
</template>

<script>
import { fromEvent, interval, merge } from "rxjs";
import { debounce } from "rxjs/operators";
import StateComments from "@/components/StateComments.vue";
import tools from "@/tools.js";

export default {
  name: "StateSignalingWriting",
  components: { StateComments },
  props: {
    context: {
      type: Object,
      required: true
    },
    human_created_on: String,
    email_set: Array
  },
  data() {
    return {
      content: null,
      text$: null,
      mhr_note$: null
    };
  },
  methods: {
    update_data(comments) {
      console.log("update data", this.content);
      this.content.data.comments = comments;
      this.$emit("state:update_data", this.content.data);
    },
    delete_state() {
      this.$emit("state:delete_state");
    }
  },
  computed: {
    hasSentEmail() {
      return (
        this.email_set.length > 0 &&
        this.email_set.some(
          (email) =>
            email.sent_on !== null && email.sent_on !== ""
        )
      );
    }
  },
  mounted() {
    const self = this;
    this.text$ = fromEvent(self.$refs.text, "input");
    this.mhr_note$ = fromEvent(self.$refs.mhr_note, "input");
    const updates_stream = merge(this.text$, this.mhr_note$).pipe(
      debounce(() => interval(500))
    );
    updates_stream.subscribe(function (event) {
      console.log("value", event);
      self.update_data(self.content.data.comments);
    });
  },
  created() {
    const self = this;
    this.content = this.context;
    // live update for comments
    self.$djangows["onmodelsignals"](
      { modelName: "state", appLabel: "state" },
      function (event) {
        if (event.obj) {
          if (event.obj.uid === self.content.uid) {
            if (
              event.signal_type === "post_save" &&
              event.created === false
            ) {
              self.content.data.comments = event.obj.data.comments;
              // self.$emit("state:update_data", self.content.data);
            }
          }
        }
      }
    );
  }
};
</script>

<style lang="scss" scoped>
</style>
